// import then needed Font Awesome functionality
import fontawesome from '@fortawesome/fontawesome';

// Import icons
import {
    faFacebook,
    faFacebookF,
    faFacebookSquare,
    faTwitter,
    faTwitterSquare,
    faLinkedin,
    faLinkedinIn,
    faInstagram,
    faInstagramSquare,
    faYoutube,
    faYoutubeSquare,
} from '@fortawesome/free-brands-svg-icons';

import {
    faPlus,
    faMinus,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faCaretDown,
} from '@fortawesome/free-solid-svg-icons';
// import { faUserCircle } from '@fortawesome/free-regular-svg-icons';

// add the imported icons to the library
fontawesome.config.searchPseudoElements = true

fontawesome.library.add(
    faPlus,
    faMinus,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faCaretDown,
    faFacebook,
    faFacebookF,
    faFacebookSquare,
    faTwitter,
    faTwitterSquare,
    faLinkedin,
    faLinkedinIn,
    faInstagram,
    faInstagramSquare,
    faYoutube,
    faYoutubeSquare
);



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js